import _ from 'underscore';
import { SelectedRouteData } from '@ve/types/SelectedRouteData';
import { Direction, Route } from '@ve/types';
import RouteModel from '../Domain/Model/RouteModelv2';

const getLegInfo = (direction: Direction | null) => _.map(direction?.legs || [], (leg) => _.pick(leg, 'tariffId', 'legId'));

export default (route: Route | RouteModel | null): SelectedRouteData | null => {
    if (!route) return null;

    const {
        routeId,
        back,
        there,
    } = route;
    return {
        routeId,
        back: getLegInfo(back),
        there: getLegInfo(there),
    };
};